import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionDelegatePayload } from 'api/actions/revision-delegate/revision-delegate-payload';
import { RevisionDelegatePathParameters } from 'api/actions/revision-delegate/revision-delegate-path-parameters';
import { RevisionDelegateResponse } from 'api/actions/revision-delegate/revision-delegate-response';

type RevisionDelegateQueryParameters = Record<string, any>;

/**
 * The path of the RevisionDelegate action.
 */
export const revisionDelegateActionPath = new SweetPath<keyof RevisionDelegatePathParameters>(
  '/api/revision/delegate/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionDelegate actions.
 */
export default function createRevisionDelegateAction(axios: AxiosInstance) {
  return function revisionDelegateAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionDelegatePathParameters;
    query?: RevisionDelegateQueryParameters;
    payload: RevisionDelegatePayload;
  }) {
    const path = revisionDelegateActionPath.insert(parameters);

    return axios.request<RevisionDelegateResponse, RevisionDelegateResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
